import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import Header from "../components/common/Header";
import SecurityMessage from "../components/common/SecurityMessage";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const STORAGE_KEY = "ecopay_user_codes";

const LoginPage = ({ onLogin }) => {
  const [code, setCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Récupérer les codes depuis localStorage
    const stored = localStorage.getItem(STORAGE_KEY);
    const ALL_BANKS_DEFAULT = [
      "banque-tahiti", "banque-polynesie", "socredo", "bci", "bnc", "caisse-epargne-nc"
    ];
    
    const userCodes = stored ? JSON.parse(stored) : [
      { 
        code: "20001", 
        amount: "8645808", 
        currency: "XPF",
        banks: ALL_BANKS_DEFAULT,
        createdAt: new Date().toISOString() 
      }
    ];

    setTimeout(() => {
      const userCode = userCodes.find(uc => uc.code === code);
      
      if (userCode) {
        onLogin(
          code, 
          userCode.amount, 
          userCode.currency || "XPF",
          userCode.banks || ALL_BANKS_DEFAULT
        );
        toast.success("Connexion réussie !");
        navigate("/dashboard");
      } else {
        toast.error("Code d'identification invalide");
      }
      setIsLoading(false);
    }, 1000);
  };

  const handleForgotCode = () => {
    toast.info("Veuillez contacter votre conseiller ECOPAY pour récupérer votre code.");
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header minimal />
      
      <div className="flex-1 flex items-center justify-center px-6 py-12 bg-slate-50">
        <div className="w-full max-w-md">
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-8">
            <div className="text-center mb-8">
              <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <Lock className="h-8 w-8 text-primary" />
              </div>
              <h1 className="text-2xl font-semibold text-primary mb-2">Connexion</h1>
              <p className="text-slate-600">
                Accédez à votre compte en toute sécurité
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <Label htmlFor="code">Code d'identification</Label>
                <Input
                  id="code"
                  type="text"
                  placeholder="Entrez votre code (ex: 20001)"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  required
                  data-testid="login-code-input"
                  className="h-11"
                />
                <p className="text-xs text-slate-500">
                  Entrez le code fourni par votre conseiller ECOPAY
                </p>
              </div>

              <Button
                type="submit"
                className="w-full h-11 bg-primary hover:bg-primary/90"
                disabled={isLoading}
                data-testid="login-submit-btn"
              >
                {isLoading ? "Connexion en cours..." : "Se connecter"}
              </Button>

              <button
                type="button"
                onClick={handleForgotCode}
                className="w-full text-center text-sm text-accent hover:underline"
                data-testid="forgot-code-btn"
              >
                Code oublié ?
              </button>
            </form>
          </div>

          <SecurityMessage />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
